// @flow
import { put, select, call, all, fork, takeLatest } from "redux-saga/effects";
import PublicEvaluationsApi from "../api/PublicEvaluations";
import { PublicEvaluations } from "../actions/actions";

// Fetch Public Evaluations Datas
function* doPublicEvaluationsFetchData(action) {
  yield put(PublicEvaluations.publicEvaluationFetchRequest());
  window.logger.log("doFetchPublicEvaluationsData", action);
  const {
    evaluationSchedulerId,
    hasGetApiRotationsOrTargets,
    token,
    trigger,
    callbackSuccess,
    callbackError,
  } = action.payload;
  try {
    const api = yield select(({ api }) => api);
    // call the api to get some datas for public evaluation
    const { data } = yield call(
      PublicEvaluationsApi.GetPublicEvaluationsDatas,
      api,
      token
    );
    let targets = [];
    if (hasGetApiRotationsOrTargets) {
      const { data } = yield call(
        PublicEvaluationsApi.GetPublicEvaluationsTargets,
        api,
        evaluationSchedulerId,
        trigger !== "custom_period" ? "rotations" : "targets",
        token
      );
      targets = data || [];
    }
    yield put(PublicEvaluations.publicEvaluationFetchSuccess());
    callbackSuccess(data, targets);
  } catch (error) {
    window.logger.log("ErrorSaga - doFetchPublicEvaluationsData", error);
    const { data: errors } = error;
    const { message, details } = errors || "";
    yield put(PublicEvaluations.publicEvaluationFetchFailure());
    let errorMsg = message;
    if (details && details.length > 0) {
      errorMsg = `${errorMsg}: ${details[0].msg}`;
    }
    callbackError(errorMsg);
  }
}
// Submit Public Evaluations Answers
function* doPublicEvaluationsSubmitAnswers(action) {
  yield put(PublicEvaluations.publicEvaluationsSubmitRequest());
  window.logger.log("doPublicEvaluationsSubmitAnswers", action);
  const { body, token, callbackSuccess, callbackError } = action.payload;
  try {
    const api = yield select(({ api }) => api);
    // call the api to submit an answer for public evaluation
    const { data } = yield call(
      PublicEvaluationsApi.SubmitPublicEvaluationsAnswers,
      api,
      token,
      body
    );
    yield put(PublicEvaluations.publicEvaluationsSubmitSuccess());
    callbackSuccess(data);
  } catch (error) {
    window.logger.log("ErrorSaga - doPublicEvaluationsSubmitAnswers", error);
    const { data: errors } = error;
    const { message, details } = errors || "";
    yield put(PublicEvaluations.publicEvaluationsSubmitFailure());
    let errorMsg = message;
    if (details && details.length > 0) {
      errorMsg = `${errorMsg}: ${details[0].msg}`;
    }
    callbackError(errorMsg);
  }
}
export default function* publicEvaluationsSubmitSagas(): Generator<*, *, *> {
  yield all([
    fork(
      takeLatest,
      PublicEvaluations.PUBLIC_EVALUATIONS_FETCH,
      doPublicEvaluationsFetchData
    ),
    fork(
      takeLatest,
      PublicEvaluations.PUBLIC_EVALUATIONS_SUBMIT,
      doPublicEvaluationsSubmitAnswers
    ),
  ]);
}
